import { Component, ChangeDetectionStrategy } from '@angular/core';
import { EasterService } from '../../easter.service';

@Component({
    selector: 'app-easter-alert',
    templateUrl: './easter-alert.component.html',
    styleUrls: ['./easter-alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class EasterAlertComponent {
    public constructor(public easterService: EasterService) {}
}
